module.exports = __webpack_public_path__ + "static/media/kr.eab3e69e.svg";